(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('CloudPBXSearch', CloudPBXSearch);

    CloudPBXSearch.$inject = ['$resource'];

    function CloudPBXSearch($resource) {
        var resourceUrl =  'api/_search/cloud-pbxes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
